import React, { useState } from 'react'
import GenericCustomButton from './GenericCustomButton'
import Icons from '../assets/icons';
import { Check, CheckCheck, Copy } from 'lucide-react';

const CopyContentGenericComponent = (props = {}) => {

    let { content, className, buttonClassName='', iconClassName='', type=1, iconColor='', label='' } = props || {};

    const [copied, setCopied] = useState(false);

    const renderBody = ()=> {
        switch (type) {
            case 1:
                return <div className={`relative flex ${className}`}>
                    <div className={`shrink-0 px-1.5 h-[26px] flex items-center justify-center rounded-full border overflow-hidden duration-200 ${label ? 'w-[80px]' : ''} ${copied ? 'text-successColor border-successColor' : 'border-transparent'}`}>
                        {copied ?
                            <div className='flex items-center justify-center gap-1.5'>
                                <CheckCheck size={15} className='text-successColor' />
                                <span className='text-xs'>Copied</span>
                            </div>
                            : <GenericCustomButton
                            tooltip="Copy"
                            leftIcon={<Copy className={`shrink-0 ${iconClassName}`} size={14} color={iconColor || '#8496A9'} />}
                            label={label}
                            onClick={(e) => {
                                e.stopPropagation();
                                setCopied(true);
                                setTimeout(() => {
                                    setCopied(false)
                                }, 4000);
                                navigator.clipboard.writeText(content)
                            }}
                            className={`flex items-center gap-1.5 whitespace-nowrap text-xs text-fontSlateGrey hover:opacity-75 ${buttonClassName}`}
                        />}
                    </div>
                </div>
                break;

                case 2:
                return <div className={`relative flex ${className}`}>
                    <div className={`shrink-0 w-[17px] h-[17px] flex items-center justify-center`}>
                        {copied ?
                            <CheckCheck size={20} className='text-successColor' />
                            : <GenericCustomButton
                            tooltip="Copy"
                            leftIcon={<Copy className={`shrink-0 ${iconClassName}`} size={14} color={iconColor || '#8496A9'} />}
                            label={label}
                            onClick={(e) => {
                                e.stopPropagation();
                                setCopied(true);
                                setTimeout(() => {
                                    setCopied(false)
                                }, 4000);
                                navigator.clipboard.writeText(content)
                            }}
                            className={`flex items-center gap-1.5 whitespace-nowrap text-xs text-fontSlateGrey  hover:opacity-75 ${buttonClassName}`}
                        />}
                    </div>
                </div>
                break;
        
            default:
                break;
        }
    }

    return (
        content && renderBody()
    )
}

export default CopyContentGenericComponent
